import { PropsWithChildren } from "react";
import { SnackbarProvider } from "notistack";

import { ApiProviderFirebase } from "@dzambalaorg/provider-api-firebase";
import { UserProviderFirebase } from "@dzambalaorg/provider-user-firebase";
import { ThemeProvider } from "@dzambalaorg/provider-theme";
import { LicenseProvider } from "@dzambalaorg/provider-license";
import { createLanguageSlice, LocalizationProvider } from "@dzambalaorg/provider-localization";
import { PopupProvider } from "@dzambalaorg/provider-popup";
import { PickerProvider } from "@dzambalaorg/provider-picker";
import { createSwitchAccountSlice, WagmiReownProvider } from "@dzambalaorg/provider-wagmi";
import { initGlobalStore } from "@dzambalaorg/store";
import { i18n } from "@framework/localization-admin-ui";
import { EnabledLanguages, ns } from "@framework/constants";

import { Signal } from "../components/signal";

initGlobalStore({ slices: [createSwitchAccountSlice, createLanguageSlice] });

export const Providers = (props: PropsWithChildren) => {
  const { children } = props;
  return (
    <ApiProviderFirebase baseUrl={process.env.BE_URL} storageName={ns}>
      <LicenseProvider licenseKey={process.env.GEMUNION_API_KEY}>
        <UserProviderFirebase>
          <ThemeProvider withTokens={true}>
            <LocalizationProvider i18n={i18n} defaultLanguage={EnabledLanguages.EN}>
              <SnackbarProvider>
                <PopupProvider>
                  <WagmiReownProvider redirectLogoutPath={"/"}>
                    <PickerProvider>
                      <Signal />
                      {children}
                    </PickerProvider>
                  </WagmiReownProvider>
                </PopupProvider>
              </SnackbarProvider>
            </LocalizationProvider>
          </ThemeProvider>
        </UserProviderFirebase>
      </LicenseProvider>
    </ApiProviderFirebase>
  );
};
